import React from 'react'

export default function RiverBackground({ mode = 'dark' }) {
  // Define our stylistic design tokens for both profiles
  const isDark = mode === 'dark'

  // High-fidelity glowing vector profiles matching your design language
  const colors = {
    bg: isDark ? '#030a04' : '#f2f8f4',
    glow1: isDark ? 'rgba(34, 197, 94, 0.22)' : 'rgba(34, 197, 94, 0.14)',   // Signature Flow Green
    glow2: isDark ? 'rgba(21, 128, 61, 0.18)' : 'rgba(56, 189, 248, 0.15)',  // Deep Emerald / Sky Blue Shift
    glow3: isDark ? 'rgba(4, 120, 87, 0.15)'  : 'rgba(134, 239, 172, 0.2)'   // Ambient Mint
  }

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      zIndex: 0,
      backgroundColor: colors.bg,
      overflow: 'hidden',
      transition: 'background-color 1.2s cubic-bezier(0.25, 1, 0.5, 1)',
      pointerEvents: 'none',
    }}>
      {/* Embedded keyframe configurations for organic fluid drift */}
      <style>{`
        @keyframes floatStreamOne {
          0% { transform: translate(0px, 0px) scale(1) rotate(0deg); }
          33% { transform: translate(40px, -60px) scale(1.15) rotate(120deg); }
          66% { transform: translate(-30px, 40px) scale(0.9) rotate(240deg); }
          100% { transform: translate(0px, 0px) scale(1) rotate(360deg); }
        }
        @keyframes floatStreamTwo {
          0% { transform: translate(0px, 0px) scale(1.1) rotate(360deg); }
          50% { transform: translate(-50px, 50px) scale(0.85) rotate(180deg); }
          100% { transform: translate(0px, 0px) scale(1.1) rotate(0deg); }
        }
        @keyframes floatStreamThree {
          0% { transform: translate(0px, 0px) scale(0.95) rotate(0deg); }
          50% { transform: translate(60px, 30px) scale(1.2) rotate(-180deg); }
          100% { transform: translate(0px, 0px) scale(0.95) rotate(0deg); }
        }
      `}</style>

      {/* Vector Layer 1: The Main River Current */}
      <div style={{
        position: 'absolute',
        top: '-20%',
        left: '-10%',
        width: '80%',
        height: '80%',
        background: `radial-gradient(circle, ${colors.glow1} 0%, rgba(0,0,0,0) 70%)`,
        filter: 'blur(80px)',
        animation: 'floatStreamOne 22s infinite linear',
        transition: 'background 1.2s ease',
      }} />

      {/* Vector Layer 2: The Cross-Current Counter Weight */}
      <div style={{
        position: 'absolute',
        bottom: '-10%',
        right: '-10%',
        width: '75%',
        height: '75%',
        background: `radial-gradient(circle, ${colors.glow2} 0%, rgba(0,0,0,0) 65%)`,
        filter: 'blur(90px)',
        animation: 'floatStreamTwo 28s infinite linear',
        transition: 'background 1.2s ease',
      }} />

      {/* Vector Layer 3: Central Ambient Depth Pulse */}
      <div style={{
        position: 'absolute',
        top: '25%',
        left: '15%',
        width: '70%',
        height: '60%',
        background: `radial-gradient(circle, ${colors.glow3} 0%, rgba(0,0,0,0) 60%)`,
        filter: 'blur(100px)',
        animation: 'floatStreamThree 18s infinite ease-in-out',
        transition: 'background 1.2s ease',
      }} />

      {/* Micro-Texture Noise Overlay to prevent gradient banding on high-end displays */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        width: '100%', height: '100%',
        opacity: isDark ? 0.015 : 0.025,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
      }} />
    </div>
  )
}